import React 		from 'react';
import ReactDOM 	from 'react-dom';
import BLComponent	from '../../core/_BLComponent.jsx';

export default class WebinarBanner extends BLComponent {
	constructor (props, context) {
		super(props, context);

		this.currentDate 		= blapp.config.server_time;
		this.series 				= blapp.models.get('listSeries') || [];
		this.seriesNumber 	= parseInt(blapp.util.getUrlInfo(window.location.href).path.split('/')[3].split('-')[1]); 
		this.seriesContent 	= this.seriesNumber ? this.series[this.series.findIndex(series => series.idSeries == this.seriesNumber)] : this.series[this.series.findIndex(series => series.strWebinarText && series.strWebinarRegistrationURL && (series.udtWebinarDate && this.currentDate <= series.udtWebinarDate))];
	}

	render() {
		const hasWebinar 	= this.seriesContent && this.seriesContent.strWebinarText && this.seriesContent.strWebinarRegistrationURL && (this.seriesContent.udtWebinarDate && this.currentDate <= this.seriesContent.udtWebinarDate);

		if(hasWebinar) {
			return (
				<article className="crowd-promotion-banner">
					<div className="crowd-promotion-banner__internal">
						<h2>{this.seriesContent.strWebinarText}</h2>
						<a className="crowd-promotion-banner__cta btn btn--outline-white text--bold" href={this.seriesContent.strWebinarRegistrationURL} target="_blank">Register now<i className="far fa-square-arrow-up-right l-margin-left--sm"/></a>
					</div>
				</article>
			);
		}else{
			return false;
		}
	}
}